import echarts from 'echarts/lib/echarts'
 
import 'echarts/lib/chart/line'
import 'echarts/lib/component/graphic'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default echarts